import axios from 'axios';

// Auth===========================================================================================

async function userSignUpApiAsync(data: any): Promise<any> {
	const config = {
		method: 'post',
		url: 'auth/signup',
		data: data
	};
	return await axios(config);
}

async function verifyOtpApiAsync(data: any): Promise<any> {
	const config = {
		method: 'post',
		url: 'auth/verify-otp',
		data: data
	};
	return await axios(config);
}
async function loginAsync(data: any): Promise<any> {
	const config = {
		method: 'post',
		url: 'auth/login',
		data: data
	};
	return await axios(config);
}

async function guestLoginAsync(data: any): Promise<any> {
	const config = {
		method: 'post',
		url: 'auth/guest-signup',
		data: data
	};
	return await axios(config);
}


async function resendOtpApiAsync(data: any): Promise<any> {
	const config = {
		method: 'post',
		url: 'auth/login',
		data: data
	};
	return await axios(config);
}

async function createDeviceApiAsync(data: any): Promise<any> {
	const config = {
		method: 'post',
		url: 'auth/device',
		data: data
	};
	return await axios(config);
}

async function authRenewTokenApiAsync(data: any): Promise<any> {
	const config = {
		method: 'post',
		url: 'auth/renew',
		data: data
	};
	return await axios(config);
}

// // Items===========================================================================================
async function getCategoriesAsync(siteId: number, orderMode: string): Promise<any> {
	const config = {
		method: 'get',
		url: `menu/categories/${siteId}/${orderMode}`,
	};
	return await axios(config);
}

// async function getSuggestionsAsync(siteId, data) {
// 	const config = {
// 		method: 'post',
// 		url: `menu/suggestions/${siteId}`,
// 		data: data
// 	};
// 	return await axios(config);
// }

// async function getPopularItemsAsync(siteId, isDelivery) {
// 	const config = {
// 		method: 'get',
// 		url: `menu/items/popular/${siteId}/${isDelivery}`,
// 	};
// 	return await axios(config);
// }

async function getItemsByCategoryAsync(siteId: number, categoryId: string, isDelivery: any, isPack = false): Promise<any> {
	const config = {
		method: 'get',
		url: `menu/items/category/${siteId}/${categoryId}?isDelivery=${isDelivery}&isPack=${isPack}`,
	};
	return await axios(config);
}

// async function getSubGroupItemsAsync(categoryId, data) {
// 	const config = {
// 		method: 'post',
// 		url: `menu/subgroups/${categoryId}`,
// 		data: data
// 	};
// 	return await axios(config);
// }

// async function getDisabledModifiersAsync(siteId) {
// 	const config = {
// 		method: 'get',
// 		url: `/menu/items/disabledItem/${siteId}`,
// 	};
// 	return await axios(config);
// }

async function getItemByIdAsync(id: any, comboId: any, siteId: any, isDelivery: any): Promise<any> {
	const config = {
		method: 'get',
		url: `menu/item/${id}/${comboId}/${siteId}/${isDelivery}`,
	};
	return await axios(config);
}

async function getItemByMenuIdAsync(menuId: any, id: any, comboId: any, siteId: any, isDelivery: boolean): Promise<any> {
	const config = {
		method: 'get',
		url: `/menu/orderkey/item/${menuId}/${id}/${comboId}/${siteId}/${isDelivery}`,
	};
	return await axios(config);
}


async function getComboItemsAsync(siteId:number, id:number, data:any, isDelivery:boolean, isPack:boolean): Promise<any> {
	const config = {
		method: 'post',
		url: `combo/items/${siteId}/${id}?isPack=${isPack}&isDelivery=${isDelivery}`,
		data: data
	};	
	return await axios(config);
}

async function getComboLevelsAsync(siteId:number, menuItemId:number, isDelivery:boolean): Promise<any> {
	const config = {
		method: 'get',
		url: `menu/combo-levels/${siteId}/${menuItemId}/${isDelivery}`,
	};
	return await axios(config);
}

async function getOrderkeyComboLevelsAsync(siteId:number, menuId:number, menuItemId:number, isDelivery:any): Promise<any>  {
	const config = {
		method: 'get',
		url: `combo/levels/${siteId}/${menuId}/${menuItemId}/${isDelivery}`,
	};
	return await axios(config);
}

async function getCustomizeItemsAsync(siteId: number, salesItemId: number, isDelivery: boolean) {
	const config = {
		method: 'get',
		url: `menu/customizeItems/${siteId}/${salesItemId}/${isDelivery}`,
	};
	return await axios(config);
}

async function getOrderkeyCustomizationsAsync(siteId: number, salesItemId: number, menuId: number, isDelivery: boolean) {
	const config = {
		method: 'get',
		url: `menu/orderkey/customizations/${salesItemId}/${menuId}/${siteId}/${isDelivery}`,
	};
	return await axios(config);
}

async function getSitesAsync(latitude: number, longitude: number, data: any): Promise<any> {
	const config = {
		method: 'post',
		url: `lookup/sites/${latitude}/${longitude}`,
		data: data
	};
	return await axios(config);
}

// //------------------------------------------------------------------ Payment API

async function createPaymentRequestAsync(selectedSiteId: number): Promise<any> {
	const config = {
		url: `payment/create-request/${selectedSiteId}`,
		method: 'post',
	};
	const result = await axios(config);
	return result;
}

// async function createWalletRequestAsync(selectedSiteId, data) {
// 	const config = {
// 		url: `payment/create-wallet-request/${selectedSiteId}`,
// 		method: 'post',
// 		data: data
// 	};
// 	const result = await axios(config);
// 	return result;
// }

async function getPaymentMethodListAsync(): Promise<any> {
	const config = {
		url: 'payment/method-list',
		method: 'get',
	};
	const result = await axios(config);
	return result;
}

async function savePaymentMethodAsync(id: string, saveforFuture: any): Promise<any> {
	const config = {
		url: `payment/method/${id}/${saveforFuture}`,
		method: 'post',
	};
	const result = await axios(config);
	return result;
}

async function deletePaymentMethodAsync(paymentMethodId: string): Promise<any> {
	const config = {
		url: `payment/method/${paymentMethodId}`,
		method: 'delete',
	};
	const result = await axios(config);
	return result;
}

async function getOrdersAsync(data: any): Promise<any> {
	const config = {
		method: 'post',
		url: 'order/my-list',
		data: data
	};
	return await axios(config);
}

// async function getActiveOrdersAsync() {
// 	const config = {
// 		method: 'get',
// 		url: 'order/active',
// 	};
// 	return await axios(config);
// }

async function getOrderDetailsAsync(orderId :any) :Promise<any> {
	const config = {
		method: 'get',
		url: `order/details/${orderId}`,
	};
	return await axios(config);
}

// async function reOrderAsync(siteId, orderId, isDelivery) {
// 	const config = {
// 		method: 'get',
// 		url: `order/re/${siteId}/${orderId}/${isDelivery}`,
// 	};
// 	return await axios(config);
// }


// async function saveAddressAsync(data) {
// 	const config = {
// 		method: 'post',
// 		url: 'sales/location',
// 		data: data
// 	};
// 	return await axios(config);
// }



// async function getAddressListAsync(siteId) {
// 	const config = {
// 		url: `sales/locations/${siteId}`,
// 		method: 'get',
// 	};
// 	const result = await axios(config);
// 	return result;
// }

// async function deleteAddressAsync(locationId) {
// 	const config = {
// 		url: `sales/location/${locationId}`,
// 		method: 'delete',
// 	};
// 	const result = await axios(config);
// 	return result;
// }

// //------------------------------------------------------------------ Add to cart

async function validateOrderAsync(data: any): Promise<any> {
	const config = {
		method: 'post',
		url: 'order/validate',
		data: data
	};
	return await axios(config);
}

async function saveOrdersAsync(data: any): Promise<any> {
	const config = {
		method: 'post',
		url: 'order/cart/save',
		data: data
	};
	return await axios(config);
}

// async function updateCartItemAsync(data) {
// 	const config = {
// 		method: 'put',
// 		url: '/order/cart/item',
// 		data: data
// 	};
// 	return await axios(config);
// }

async function saveOrderAsync(orderId: string, latitude: any, longitude: any): Promise<any> {
	const config = {
		method: 'post',
		url: `order/save/${orderId}/${latitude}/${longitude}`,
	};
	return await axios(config);
}

// async function cancelOrderAsync(orderId) {
// 	const config = {
// 		method: 'delete',
// 		url: `order/cancel/${orderId}`,
// 	};
// 	return await axios(config);
// }
// //-----------------------------------------------------------------------------------------

// async function getFeedbackCategoriesAsync() {
// 	const config = {
// 		method: 'get',
// 		url: 'lookup/categories',
// 	};
// 	return await axios(config);
// }

// async function getAppRevisionAsync(versionNumber) {
// 	const config = {
// 		method: 'get',
// 		url: `lookup/app-update/${versionNumber}`,
// 	};
// 	return await axios(config);
// }

// async function createFeedbackAsync(data) {
// 	const config = {
// 		method: 'post',
// 		url: 'feedback',
// 		data: data
// 	};
// 	return await axios(config);
// }

async function getBannersAsync(id: number) {
	const config = {
		method: 'get',
		url: `lookup/banners/${id}`
	};
	return await axios(config);
}

async function getUserProfileAsync(): Promise<any> {
	const config = {
		method: 'get',
		url: 'user/detail'
	}
	return await axios(config);
}

async function updateUserProfileAsync(data: any): Promise<any> {
	const config = {
		method: 'put',
		url: 'user/profile',
		data: data
	};
	return await axios(config);
}

// async function updateUserEmailSettingsAsync() {
// 	const config = {
// 		method: 'put',
// 		url: 'user/email-settings',

// 	};
// 	return await axios(config);
// }


async function deleteUserProfileAsync(): Promise<any> {
	const config = {
		method: 'delete',
		url: 'user/profile',
	};
	return await axios(config);
}

// async function getPreSignedUrlAsync() {
// 	const config = {
// 		url: 'file/sas-app-url/',
// 		method: 'get'
// 	};
// 	const result = await axios(config);
// 	return result;
// }

// async function uploadImageAsync(url, image) {
// 	const response = await fetch(url, {
// 		method: 'Put',
// 		headers: {
// 			'x-ms-blob-type': 'BlockBlob',
// 		},
// 		body: image
// 	});

// 	return response;
// }

async function getPointLogAsync(): Promise<any> {
	const config = {
		url: 'payment/points',
		method: 'get'
	};
	const result = await axios(config);
	return result;
}

async function getUserInfoAsync(appVersion:any, data:any): Promise<any> {
	const config = {
		url: `user/info/${appVersion}`,
		method: 'post',
		data: data,
	};
	const result = await axios(config);
	return result;
}

async function updateUserPhoneAsync(data: any): Promise<any> {
	const config = {
		method: 'post',
		url: '/user/generate-otp',
		data: data
	};
	return await axios(config);
}

// async function verifyUserPhoneAsync(data) {
// 	const config = {
// 		method: 'post',
// 		url: '/user/verify-otp',
// 		data: data
// 	};

// 	return await axios(config);
// }

// async function getDeliveryChargesAsync(siteId, locationId) {
// 	const config = {
// 		method: 'post',
// 		url: `/order/delivery/estimate/${siteId}/${locationId}`
// 	};
// 	return await axios(config);
// }

// async function generateQrCodeAsync() {
// 	const config = {
// 		method: 'get',
// 		url: '/auth/qrcode'
// 	};
// 	return await axios(config);
// }

async function getAssignedMenusBySiteIdAsync(siteId: any): Promise<any> {
	const config = {
		method: 'get',
		url: `/item/menus/${siteId}`,
	}
	return await axios(config);
}

export default {
	userSignUpApiAsync,
	verifyOtpApiAsync,
	loginAsync,
	guestLoginAsync,
	resendOtpApiAsync,
	createDeviceApiAsync,
	authRenewTokenApiAsync,

	getCategoriesAsync,
	// getPopularItemsAsync,
	getItemsByCategoryAsync,
	// getSubGroupItemsAsync,
	getItemByIdAsync,
	getItemByMenuIdAsync,
	getCustomizeItemsAsync,
	getOrderkeyCustomizationsAsync,
	getComboItemsAsync,
	getSitesAsync,
	// getDisabledModifiersAsync,

	createPaymentRequestAsync,
	// createWalletRequestAsync,
	getPaymentMethodListAsync,
	savePaymentMethodAsync,
	deletePaymentMethodAsync,

	getOrdersAsync,
	getOrderDetailsAsync,
	// getActiveOrdersAsync,

	// saveAddressAsync,
	// getAddressListAsync,
	// deleteAddressAsync,

	// getFeedbackCategoriesAsync,
	// getAppRevisionAsync,
	// createFeedbackAsync,

	getBannersAsync,
	saveOrderAsync,
	validateOrderAsync,
	saveOrdersAsync,
	// updateCartItemAsync,
	// reOrderAsync,
	// cancelOrderAsync,

	getUserProfileAsync,
	// updateUserEmailSettingsAsync,
	updateUserProfileAsync,
	deleteUserProfileAsync,
	// getPreSignedUrlAsync,
	// uploadImageAsync,

	getPointLogAsync,
	getUserInfoAsync,

	updateUserPhoneAsync,
	// verifyUserPhoneAsync,

	// getDeliveryChargesAsync,
	// generateQrCodeAsync,
	getComboLevelsAsync,
	getOrderkeyComboLevelsAsync,
	// getSuggestionsAsync,
	getAssignedMenusBySiteIdAsync
};	